import Fecha from 'fecha'
import type { EventItem } from '@tixa/schema'
import { component } from 'knockout-decorators'

import source from './item-event.html?raw'
import './item-event.less'

type EventItemParams = EventItem & { onSelect?: () => void }

@component('item-event', source)
export class EventGUI {
  private data: EventItemParams

  constructor(params: EventItemParams) {
    this.data = params
  }

  /** Call optional analytics callback then allow link to navigate. */
  public handleLinkClick(): boolean {
    if (typeof this.data.onSelect === 'function') {
      this.data.onSelect()
    }
    return true
  }

  public getEventMonth(date: string): string {
    return Fecha.format(new Date(date), 'MMMM')
  }

  public getEventDay(date: string): string {
    return Fecha.format(new Date(date), 'DD')
  }
}
